/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper';
import { Col, Row, Table } from 'react-bootstrap-v5';
import 'react-dropzone-uploader/dist/styles.css'
import { useParams } from 'react-router-dom'
import { KTSVG } from '../../_metronic/helpers'
import SalesPaymentCreate from '../components/SalesPaymentCreate'
import GetPagePermission from '../components/GetPagePermission'
import AdvancePaymentAdjustmentModal from '../components/AdvancePaymentAdjustmentModal';
import Dropzone from 'react-dropzone-uploader'
import clsx from 'clsx'
import Swal from 'sweetalert2'
import showLoader from '../helpers/ShowLoader'
import validationErrorMsg from '../helpers/ValidationErrorMsg'
import axios, { AxiosResponse, AxiosError } from 'axios'


interface SalesInvoice {
    id_sales_invoice: number;
    id_leads: number;
    idSalesInvoice: number;
    createdBy: number;
    invoiceId: string;
    referenceNo: string;
    idSalesOrders: number;
    sales_order: {
        idSalesOrder: number;
        idCompanies: number;
        project: any;
        lead: any;
        company: any;
    };
    invoiceDate: string;
    totalAmount: number;
    invoiceAmount: number;
    returnTotalAmount?: number;
    isReturnOnly?: boolean;
    createdAt: any;
    vatAmount: string;
    discountAmount: string;
    advanceAdjustment: string;
    netAmount: string;
    voucher: any;
    creator: {
        name: string;
    };
    comments: { id_sales_invoice: number, comment: string, created_at: string, creator: any }[];
    attachments: { id_sales_invoice: number, attachment_name: string, attachment_path: string, file_size: number, created_at: string, creator: any }[];
    items: { id_sales_invoice: number, delivered_quantity: number, delivered_amount: number, sales_order_row: any, product_name: string, product: any }[];
    free_items: { id_sales_invoice: number, delivered_quantity: number, sales_order_free_row: any, product_name: string, product: any }[];
    returns: {
        id_sales_invoice_returns: number;
        id_sales_order_returns: number;
        sales_order_return: {
            id_sales_order_returns: number;
            return_date: string;
            remarks: string;
            creator: { first_name: string; last_name: string };
            rows: {
                id_sales_order_return_rows: number;
                quantity: number;
                sales_order_row: any;
            }[];
        };
    }[];

    project: {
        projectName: string;
    };
    lead: {
        leadName: string;
    };
    quotation: {
        referenceNumber: string;
    };

    shipments: {
        idShipments: string,
        id_shipments: string
    }[];
    payments: {
        id_sales_payments: number, transaction_id: string, payment_amount: number, creator: any
        , payment_date: string, payment_method: string, payment_type: string, remarks: string, paymentInfo: string
    }[];
    advanceAdjustments?: {
        id_sales_invoice_advance_adjustments: number;
        adjusted_amount: number;
        created_at: string;
        creator?: { first_name?: string; last_name?: string };
        details?: {
            id_sales_invoice_adjustment_details: number;
            id_sales_payments: number;
            adjusted_amount: number;
            salesPayment?: {
                id_sales_payments: number;
                payment_date: string;
                payment_method: string;
                transaction_id: string;
                creator?: { first_name?: string; last_name?: string };
            };
        }[];
    }[];
}

interface SalesOrder {
    id_sales_invoice: number;
    idSalesInvoice: number;
    idSalesOrders: number;
    id_sales_orders: number;
    id_projects: number;
    idProjects: number;
    idCompanies?: number;
    id_companies?: number;
    projectName: string;
    companyName?: string;
}

interface RouteParams {
    idSalesInvoice: string;
}

const getReadableFileSizeString = (fileSizeInBytes: number) => {
    return ((fileSizeInBytes / (1024 * 1024)).toFixed(4) + " MB");
}


export function SalesInvoiceDetails(props: any) {

    const [tab, setTab] = useState('Sidebar')
    const [salesInvoiceInfo, setSalesInvoiceInfo] = useState<SalesInvoice | null>(null);
    const [salesOrderInfo, setSalesOrderInfo] = useState<SalesOrder | null>(null);
    const { idSalesInvoice }: RouteParams = useParams();
    const [message, setMessage] = useState('')

    const [showAdvanceAdjustmentModal, setShowAdvanceAdjustmentModal] = useState(false);
    const [adjustmentModalData, setAdjustmentModalData] = useState<{
        idCompanies: number;
        idProjects: number;
        maxAdjustableAmount: number;
        totalInvoiceAmount: number;
        vatAmount: number;
        discountAmount: number;
    } | null>(null);

    const hasPaymentCreatePermission = GetPagePermission('/sales-payment-create');
    const hasAdjustmentPermission = GetPagePermission('/sales-invoice-adjustment');
    const hasDownloadPermission = GetPagePermission('/sales-invoice-download');
    const hasViewPermission = GetPagePermission('/sales-invoice-view');
    const hasDownloadWithoutDiscountPermission = GetPagePermission('/sales-invoice-download-without-discount');
    const [createPaymentModalShow, setCreatePaymentModalShow] = useState(false);
    const getInvoiceSalesOrder = (invoice: SalesInvoice | null | undefined) =>
        (invoice as any)?.sales_order ?? (invoice as any)?.salesOrder;
    const showInvoiceWeight = (invoice: SalesInvoice | null | undefined) => {
        const project = getInvoiceSalesOrder(invoice)?.project;
        const flag = project?.showWeight ?? project?.show_weight;
        return String(flag || '').toLowerCase() === 'yes';
    };
    const handleCreatePaymentModalClose = (isReload: boolean) => {
        setCreatePaymentModalShow(false);
        getSalesInvoiceInfo();
    }

    const makeAdjustment = (idSalesInvoice: number) => {
        fetch(process.env.REACT_APP_API_URL + 'sales-invoice/adjustment/' + idSalesInvoice, getRequestOptions())
            .then((resp) => resp.json())
            .then((resp) => {
                const inv = resp.data;
                const so = inv?.sales_order ?? inv?.salesOrder;
                const idCompanies = (so?.id_companies ?? so?.idCompanies) ?? 0;
                const idProjects = (so?.id_projects ?? so?.idProjects) ?? 0;
                const invoiceAmount = parseFloat(inv?.invoice_amount ?? inv?.invoiceAmount ?? 0);
                setAdjustmentModalData({
                    idCompanies,
                    idProjects,
                    maxAdjustableAmount: resp.maxAdjustableAmount ?? 0,
                    totalInvoiceAmount: invoiceAmount,
                    vatAmount: 0,
                    discountAmount: 0,
                });
                setShowAdvanceAdjustmentModal(true);
            })
            .catch((error) => {
                console.log(error, 'adjustment fetch');
                Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to load adjustment data.' });
            });
    }

    const handleAdvanceAdjustmentClose = () => {
        setShowAdvanceAdjustmentModal(false);
        setAdjustmentModalData(null);
        getSalesInvoiceInfo();
    }

    const numberFormat = (value: any) => {

        value = parseFloat(value)
        if (typeof (value) !== 'number' || isNaN(value)) {
            return value;
        }
        return parseFloat(value.toString()).toLocaleString('en-US', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    const getReturnRow = (row: any) => row?.sales_order_row ?? row?.salesOrderRow ?? {};

    const getReturnRowRate = (row: any) => {
        const orderRow = getReturnRow(row);
        return parseFloat(orderRow?.unit_rate ?? orderRow?.unitRate ?? 0);
    }

    const getReturnRowAmount = (row: any) => {
        const quantity = parseFloat(row?.quantity ?? 0);
        return quantity * getReturnRowRate(row);
    }

    const isReturnOnlyInvoice = () => {
        return Boolean(
            salesInvoiceInfo?.isReturnOnly ??
            ((salesInvoiceInfo?.items?.length ?? 0) === 0 && (salesInvoiceInfo?.returns?.length ?? 0) > 0)
        );
    }

    const getItemsNetAmount = () => {
        if (isReturnOnlyInvoice()) {
            return 0;
        }
        return Number(salesInvoiceInfo?.invoiceAmount ?? 0) - Number(salesInvoiceInfo?.advanceAdjustment ?? 0);
    }

    const getReturnTotalAmount = () => {
        if (salesInvoiceInfo?.returnTotalAmount != null) {
            return Number(salesInvoiceInfo.returnTotalAmount);
        }
        return (salesInvoiceInfo?.returns ?? []).reduce((total, ret) => {
            const salesOrderReturn = (ret as any)?.sales_order_return ?? (ret as any)?.salesOrderReturn;
            const rows = salesOrderReturn?.rows ?? [];
            return total + rows.reduce((rowTotal: number, row: any) => rowTotal + getReturnRowAmount(row), 0);
        }, 0);
    }

    const getReturnNetAmount = () => {
        return Number(salesInvoiceInfo?.invoiceAmount ?? 0) - Number(salesInvoiceInfo?.advanceAdjustment ?? 0);
    }

    useEffect(() => {
        console.log(idSalesInvoice)
        if (idSalesInvoice !== undefined) {
            getSalesInvoiceInfo()
        }
    }, [idSalesInvoice])

    const getSalesInvoiceInfo = () => {
        fetch(
            process.env.REACT_APP_API_URL + 'sales-invoice/' + idSalesInvoice,
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                const data: SalesInvoice = resp.data;
                setSalesInvoiceInfo(data);
                const so = data.sales_order ?? (data as any).salesOrder;
                const proj = so?.project;
                const comp = so?.company;
                setSalesOrderInfo({
                    id_sales_invoice: parseInt(idSalesInvoice),
                    idSalesInvoice: parseInt(idSalesInvoice),
                    idSalesOrders: data.idSalesOrders ?? (data as any).id_sales_orders,
                    id_sales_orders: data.idSalesOrders ?? (data as any).id_sales_orders,
                    idProjects: proj?.id_projects ?? (proj as any)?.idProjects,
                    idCompanies: (so as any)?.id_companies ?? so?.idCompanies,
                    id_companies: (so as any)?.id_companies ?? so?.idCompanies,
                    id_projects: proj?.id_projects ?? (proj as any)?.idProjects,
                    projectName: proj?.projectName ?? (proj as any)?.project_name,
                    companyName: (comp as any)?.company_name ?? comp?.companyName,
                })
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const handlePaymentModalShow = (salesOrderInfo: any) => {
        setSalesOrderInfo(salesOrderInfo);
        setCreatePaymentModalShow(true);
    }

    const sendMessage = async () => {
        showLoader()
        const formData = {
            idSalesInvoice: idSalesInvoice,
            message: message
        };
        const requestOptions = postRequestOptions(formData)
        try {
            let response = await fetch(
                `${process.env.REACT_APP_API_URL}sales-invoice/comment`,
                requestOptions
            )
            let respData = await response.json()
            Swal.close();
            if (respData.success === true) {
                setMessage('');
                getSalesInvoiceInfo()
            } else {
                const errorsMessage = validationErrorMsg(respData.errors).join('<br>')
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    html: errorsMessage,
                })
            }

        } catch (error) {
            console.log(error, 'catch the hoop')
            Swal.close();
        }
    }

    const jwt = () => {
        const myToken = localStorage.getItem('MyToken');
        return (myToken != null) ? JSON.parse(myToken) : null;
    }

    const handleFileSubmit = (files: any, allFiles: []) => {
        showLoader()

        const postFormData = new FormData();
        postFormData.append('idSalesInvoice', idSalesInvoice.toString());
        for (let i = 0; i < files.length; i++) {
            postFormData.append('files[]', files[i].file);
        }

        const url: string = `${process.env.REACT_APP_API_URL}sales-invoice/file-upload`;

        axios({
            method: 'POST',
            url: url,
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: 'Bearer ' + jwt(),
            },
            data: postFormData,
        })
            .then((response: AxiosResponse<any>) => {
                Swal.close();
                allFiles.forEach((f: any) => f.remove());
                getSalesInvoiceInfo();
            })
            .catch((error: AxiosError<any>) => {
                Swal.close();
                // const errorMessage: string = error.response?.data?.errorMessage;
                const errorsMessage: string = validationErrorMsg(error?.response?.data?.errors).join('<br>');
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    html: errorsMessage,
                });
            });

    }

    return (<>
        <div className='card card-custom'>
            <div className='card-header card-header-stretch overflow-auto'>
                <div className='card-title'>
                    <h3 className='card-label'>Sales Invoice Details</h3>
                    <small className='text-muted'>| Information about the sales Invoice</small>
                </div>
            </div>
            <div className="card-body">

            </div>
        </div>

        <Row>
            {/* <pre>{JSON.stringify(salesOrderInfo, null, 2)}</pre> */}
            <Col md={4} className="pe-0 pt-0">
                <div className="card card-flush overflow-hidden m-2 me-0">
                    <div className="card-header py-5">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label fw-bold text-dark">Summary</span>
                        </h3>
                    </div>
                    <div className="card-body pt-0">
                        <Table striped bordered hover size='sm'>
                            <tbody>
                                <tr>
                                    <td style={{ width: '50%' }}>ID</td>
                                    <td style={{ width: '50%' }}>{salesInvoiceInfo?.id_sales_invoice}</td>
                                </tr>
                                <tr>
                                    <td>Invoice ID</td>
                                    <td>{salesInvoiceInfo?.invoiceId}</td>
                                </tr>
                                <tr>
                                    <td>Reference No.</td>
                                    <td>{salesInvoiceInfo?.referenceNo}</td>
                                </tr>
                                <tr>
                                    <td>Invoice Date</td>
                                    <td>{salesInvoiceInfo?.invoiceDate}</td>
                                </tr>
                                <tr>
                                    <td>Sales Order ID</td>
                                    <td>{salesInvoiceInfo?.idSalesOrders}</td>
                                </tr>
                                <tr>
                                    <td>Project</td>
                                    <td>{salesInvoiceInfo?.sales_order?.project?.projectName}</td>
                                </tr>
                                <tr>
                                    <td>Shipments</td>
                                    <td>
                                        {salesInvoiceInfo?.shipments?.map((x, y) => (
                                            <span>{x.id_shipments}, </span>
                                        ))}
                                    </td>
                                </tr>
                                {/* <tr>
                                    <td>Acc Voucher</td>
                                    <td>

                                    </td>
                                </tr> */}
                                <tr>
                                    <td>Creator</td>
                                    <td>{salesInvoiceInfo?.creator.name + ' at ' + salesInvoiceInfo?.createdAt}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                </div>


                <div className="card card-flush overflow-hidden m-2 me-0">
                    <div className="card-header py-5">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label fw-bold text-dark">Lead Details</span>
                        </h3>
                    </div>
                    <div className="card-body pt-0">
                        <Table striped bordered hover size='sm'>
                            <tbody>
                                <tr>
                                    <td style={{ width: '50%' }}>Lead Name</td>
                                    <td style={{ width: '50%' }}>{salesInvoiceInfo?.sales_order?.lead?.leadName}</td>
                                </tr>
                                <tr>
                                    <td>Client</td>
                                    <td>{salesInvoiceInfo?.sales_order?.company?.company_name}</td>
                                </tr>
                                <tr>
                                    <td>Category</td>
                                    <td>{salesInvoiceInfo?.sales_order?.company?.company_category?.category_name}</td>
                                </tr>
                                <tr>
                                    <td>Address</td>
                                    <td>{salesInvoiceInfo?.sales_order?.company?.company_address}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                </div>

                <div className='card card-custom'>
                    <div className='card-header card-header-stretch overflow-auto'>
                        <ul
                            className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap'
                            role='tablist'
                        >
                            <li className='nav-item p-2'>
                                <a
                                    className={clsx(`nav-link cursor-pointer`, { active: tab === 'Sidebar' })}
                                    onClick={() => setTab('Sidebar')}
                                    role='tab'
                                >
                                    <KTSVG className='svg-icon-3 me-2' path="/media/svg/icons/Communication/Chat6.svg"></KTSVG>
                                    Add comment
                                </a>
                            </li>
                            <li className='nav-item p-2'>
                                <a
                                    className={clsx(`nav-link cursor-pointer`, { active: tab === 'Toolbar' })}
                                    onClick={() => setTab('Toolbar')}
                                    role='tab'
                                >
                                    <KTSVG className='svg-icon-3 me-2' path="/media/svg/icons/General/Clip.svg"></KTSVG>
                                    Attach files
                                </a>
                            </li>
                        </ul>
                    </div>


                    <div className='card-body'>
                        <div className='tab-content pt-3'>
                            <div className={clsx('tab-pane', { active: tab === 'Sidebar' })}>

                                <Table striped bordered hover size='sm'>
                                    <thead>
                                        <tr>
                                            <th style={{ width: '50%' }}>Comment</th>
                                            <th style={{ width: '50%' }}>Comment By</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {salesInvoiceInfo?.comments?.length === 0 &&
                                            <tr>
                                                <td colSpan={2}>No comments available</td>
                                            </tr>
                                        }
                                        {salesInvoiceInfo?.comments?.map((comment, index) => (
                                            <tr>
                                                <td key={'comment' + index}>{comment.comment}</td>
                                                <td>{comment.creator.first_name + ' ' + comment.creator.last_name + ' at ' + comment.created_at}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                                <textarea
                                    className='form-control  mb-3'
                                    rows={3}
                                    data-kt-element='input'
                                    placeholder='Type a message'
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                ></textarea>
                                <div className='d-flex flex-row justify-content-end'>

                                    <button
                                        className='btn-sm btn-success'
                                        type='button'
                                        onClick={sendMessage}
                                    >
                                        Send
                                    </button>
                                </div>
                            </div>

                            <div className={'p-0 ' + clsx('tab-pane', { active: tab === 'Toolbar' })}>

                                <Table striped bordered hover size='sm'>
                                    <thead>
                                        <tr>
                                            <th style={{ width: '50%' }}>Attachment</th>
                                            <th style={{ width: '50%' }}>Uploaded By</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {salesInvoiceInfo?.attachments?.length === 0 &&
                                            <tr>
                                                <td colSpan={2}>No File Attached</td>
                                            </tr>
                                        }
                                        {salesInvoiceInfo?.attachments?.map((attachment, index) => (
                                            <tr>
                                                <td key={'attachment' + index}>
                                                    <a rel='noreferrer' href={process.env.REACT_APP_AWS_URL + "salesOrders/" + attachment.attachment_path}
                                                        className="fs-6 text-hover-primary fw-bold" target="_blank">{attachment.attachment_name}</a>
                                                    <div className="text-gray-400">{getReadableFileSizeString(attachment.file_size)}</div>
                                                </td>
                                                <td>{attachment.creator.first_name + ' ' + attachment.creator.last_name + ' at ' + attachment.created_at}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>

                                <Dropzone
                                    styles={{ dropzone: { border: "none" } }}
                                    accept='image/*,audio/*,application/pdf'
                                    onSubmit={handleFileSubmit}
                                />
                            </div>
                        </div>
                    </div>

                </div>



            </Col>
            <Col md={8} className="pt-2">

                <div className="card card-flush overflow-hidden m-2 me-0">
                    <div className="card-header py-5">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label fw-bold text-dark">Items</span>
                        </h3>
                    </div>
                    
                    <div className="card-body pt-0">
                        <Table striped bordered hover size="sm">
                            <thead>
                                <tr>
                                    <th>Product</th>
                                    <th>Packing</th>
                                    <th>Unit</th>
                                    <th>Ordered Quantity</th>
                                    <th>Delivered Quantity</th>
                                    {(showInvoiceWeight(salesInvoiceInfo)) && (
                                        <>
                                            <th>Weight (KG)</th>
                                            <th>Total Weight</th>
                                        </>
                                    )}
                                    <th>Rate</th>
                                    <th>Amount</th>
                                </tr>
                            </thead>
                            <tbody>

                                {salesInvoiceInfo?.items?.length === 0 && (
                                    <tr>
                                        <td colSpan={showInvoiceWeight(salesInvoiceInfo) ? 9 : 7} className="text-center text-muted">No delivered items</td>
                                    </tr>
                                )}
                                {salesInvoiceInfo?.items?.map((item, index) => {
                                    const orderRow = item?.sales_order_row ?? (item as any)?.salesOrderRow;
                                    const weightInKg = orderRow?.weight_in_kg ?? orderRow?.weightInKg;
                                    const showWeight = showInvoiceWeight(salesInvoiceInfo);
                                    return (
                                        <tr key={'item' + index}>
                                            <td>{orderRow?.alternate_name != null ? orderRow?.alternate_name?.alternate_name : (orderRow?.alternateName?.alternate_name ?? orderRow?.product?.product_name)}</td>
                                            <td>{orderRow?.product?.packing +' '+ orderRow?.product?.item?.unit?.unit_name}</td>
                                            <td>{orderRow?.product?.unit?.unit_name}</td>
                                            <td>{orderRow?.quantity}</td>
                                            <td>{item?.delivered_quantity}</td>
                                            {showWeight && (
                                                <td className='text-end'>
                                                    {weightInKg != null && weightInKg !== ''
                                                        ? numberFormat(weightInKg)
                                                        : '-'}
                                                </td>
                                            )}
                                            {showWeight && (
                                                <td className='text-end'>
                                                    {weightInKg != null && weightInKg !== ''
                                                        ? numberFormat(Number(weightInKg) * Number(item?.delivered_quantity ?? 0))
                                                        : '-'}
                                                </td>
                                            )}
                                            <td className='text-end'>{numberFormat(orderRow?.unit_rate)}</td>
                                            <td className='text-end'>{numberFormat(item?.delivered_amount)}</td>
                                        </tr>
                                    );
                                })}
                                {(() => {
                                    const amountLabelColSpan = showInvoiceWeight(salesInvoiceInfo) ? 8 : 6;
                                    return (
                                        <>
                                <tr>
                                    <td colSpan={amountLabelColSpan} className='text-end'><b>Total Amount : </b></td>
                                    <td className='text-end'><b>{numberFormat(isReturnOnlyInvoice() ? 0 : salesInvoiceInfo?.totalAmount)}</b></td>
                                </tr>
                                {!isReturnOnlyInvoice() && Number(salesInvoiceInfo?.vatAmount ?? 0) !== 0 && (
                                <tr>
                                    <td colSpan={amountLabelColSpan} className='text-end'><b>VAT Amount : </b></td>
                                    <td className='text-end'><b>{numberFormat(salesInvoiceInfo?.vatAmount)}</b></td>
                                </tr>
                                )}
                                {!isReturnOnlyInvoice() && Number(salesInvoiceInfo?.discountAmount ?? 0) !== 0 && (
                                <tr>
                                    <td colSpan={amountLabelColSpan} className='text-end'><b>Discount Amount : </b></td>
                                    <td className='text-end'><b>{numberFormat(salesInvoiceInfo?.discountAmount)}</b></td>
                                </tr>
                                )}
                                {!isReturnOnlyInvoice() && Number(salesInvoiceInfo?.advanceAdjustment ?? 0) !== 0 && (
                                <tr>
                                    <td colSpan={amountLabelColSpan} className='text-end'><b>Adjustment : </b></td>
                                    <td className='text-end'><b>{numberFormat(salesInvoiceInfo?.advanceAdjustment)}</b></td>
                                </tr>
                                )}
                                {!isReturnOnlyInvoice() && (
                                <tr>
                                    <td colSpan={amountLabelColSpan} className='text-end'><b>Net Amount : </b></td>
                                    <td className='text-end'><b>{numberFormat(getItemsNetAmount())}</b></td>
                                </tr>
                                )}
                                {showInvoiceWeight(salesInvoiceInfo) && (
                                <tr>
                                    <td colSpan={amountLabelColSpan} className='text-end'><b>Overall Weight : </b></td>
                                    <td className='text-end'><b>{numberFormat(
                                        (salesInvoiceInfo?.items ?? []).reduce((sum, item) => {
                                            const orderRow = item?.sales_order_row ?? (item as any)?.salesOrderRow;
                                            const weightInKg = orderRow?.weight_in_kg ?? orderRow?.weightInKg;
                                            if (weightInKg == null || weightInKg === '') return sum;
                                            return sum + (Number(weightInKg) * Number(item?.delivered_quantity ?? 0));
                                        }, 0)
                                    )} Kg</b></td>
                                </tr>
                                )}
                                        </>
                                    );
                                })()}
                            </tbody>
                        </Table>

                        <div className='row'>
                            <div className='col d-flex flex-wrap justify-content-center gap-5'>
                                {hasAdjustmentPermission === 1 &&
                                    <button className="btn btn-primary btn-sm" onClick={() => makeAdjustment((salesInvoiceInfo as any)?.id_sales_invoice ?? salesInvoiceInfo?.idSalesInvoice ?? 0)}>
                                        <KTSVG
                                            path='/media/svg/icons/Design/Crop.svg'
                                            className='svg-icon-5 svg-icon'
                                        />		Adjustment
                                    </button>
                                }
                                {hasPaymentCreatePermission === 1 &&
                                    <button className="btn btn-primary btn-sm" onClick={() => handlePaymentModalShow(salesOrderInfo)}>
                                        <KTSVG
                                            path='/media/svg/icons/Shopping/Cart3.svg'
                                            className='svg-icon-5 svg-icon'
                                        />		Make Payment
                                    </button>
                                }
                                {hasDownloadPermission === 1 &&
                                    <a className="btn btn-primary btn-sm" target="_blank" rel="noopener noreferrer" href={`${process.env.REACT_APP_BACKEND}invoiceDownload/${salesInvoiceInfo?.id_sales_invoice}?type=with_discount`}>
                                        <KTSVG
                                            path='/media/svg/icons/Files/Downloads-folder.svg'
                                            className='svg-icon-5 svg-icon'
                                        />		Download
                                    </a>
                                }
                                {hasViewPermission === 1 &&
                                    <a className="btn btn-primary btn-sm" target="_blank" rel="noopener noreferrer" href={`${process.env.REACT_APP_BACKEND}invoiceView/${salesInvoiceInfo?.id_sales_invoice}?type=with_discount`}>
                                        <KTSVG
                                            path='/media/svg/icons/General/Visible.svg'
                                            className='svg-icon-5 svg-icon'
                                        />		Invoice View
                                    </a>
                                }
                                {hasDownloadWithoutDiscountPermission === 1 &&
                                    <a className="btn btn-primary btn-sm" target="_blank" rel="noopener noreferrer" href={`${process.env.REACT_APP_BACKEND}invoiceDownload/${salesInvoiceInfo?.id_sales_invoice}?type=without_discount`}>
                                        <KTSVG
                                            path='/media/svg/icons/Files/Downloads-folder.svg'
                                            className='svg-icon-5 svg-icon'
                                        />		Download Without Discount
                                    </a>
                                }

                            </div>
                        </div>

                    </div>
                </div>

                <div className="card card-flush overflow-hidden m-2 me-0">
                    <div className="card-header py-5">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label fw-bold text-dark">Free Items</span>
                        </h3>
                    </div>
                    
                    <div className="card-body pt-0">
                        <Table striped bordered hover size="sm">
                            <thead>
                                <tr>
                                    <th>Product</th>
                                    <th>Packing</th>
                                    <th>Unit</th>
                                    <th>Ordered Quantity</th>
                                    <th>Delivered Quantity</th>
                                </tr>
                            </thead>
                            <tbody>

                                {salesInvoiceInfo?.free_items?.map((item, index) => (
                                    <>
                                        <tr key={'item' + index}>
                                            <td>{item?.sales_order_free_row?.alternate_name !== null ? item?.sales_order_free_row?.alternate_name?.alternate_name : item?.sales_order_free_row?.product?.product_name}</td>
                                            <td>{item?.sales_order_free_row?.product?.packing +' '+ item?.sales_order_free_row?.product?.item.unit.unit_name}</td>
                                            <td>{item?.sales_order_free_row?.product?.unit.unit_name}</td>
                                            <td>{item?.sales_order_free_row?.quantity}</td>
                                            <td>{item?.delivered_quantity}</td>
                                            
                                        </tr>
                                    </>

                                ))}
                            </tbody>
                        </Table>

                    </div>
                </div>

                {salesInvoiceInfo?.returns && salesInvoiceInfo.returns.length > 0 && (
                <div className="card card-flush overflow-hidden m-2 me-0">
                    <div className="card-header py-5">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label fw-bold text-dark">Returned Items</span>
                        </h3>
                    </div>
                    
                    <div className="card-body pt-0">
                        {salesInvoiceInfo.returns.map((ret, retIndex) => {
                            const salesOrderReturn = (ret as any)?.sales_order_return ?? (ret as any)?.salesOrderReturn;
                            return (
                            <div key={'return' + retIndex} className={retIndex > 0 ? 'mt-4' : ''}>
                                <div className="d-flex align-items-center mb-2">
                                    <span className="badge badge-light-danger me-2">Return #{salesOrderReturn?.id_sales_order_returns ?? salesOrderReturn?.idSalesOrderReturns}</span>
                                    <small className="text-muted">
                                        {salesOrderReturn?.return_date ?? salesOrderReturn?.returnDate}
                                        {salesOrderReturn?.creator && (
                                            <> &middot; {salesOrderReturn.creator.first_name} {salesOrderReturn.creator.last_name}</>
                                        )}
                                    </small>
                                    {salesOrderReturn?.remarks && (
                                        <small className="text-muted ms-2">({salesOrderReturn.remarks})</small>
                                    )}
                                </div>
                                <Table striped bordered hover size="sm">
                                    <thead>
                                        <tr>
                                            <th>Product</th>
                                            <th>Packing</th>
                                            <th>Unit</th>
                                            <th>Returned Quantity</th>
                                            <th>Rate</th>
                                            <th>Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(salesOrderReturn?.rows ?? []).map((row: any, rowIndex: number) => {
                                            const orderRow = getReturnRow(row);
                                            const product = orderRow?.product ?? {};
                                            const alternateName = orderRow?.alternate_name ?? orderRow?.alternateName;
                                            return (
                                            <tr key={'returnRow' + retIndex + '-' + rowIndex}>
                                                <td>{alternateName != null ? alternateName?.alternate_name : product?.product_name}</td>
                                                <td>{product?.packing + ' ' + product?.item?.unit?.unit_name}</td>
                                                <td>{product?.unit?.unit_name}</td>
                                                <td>{row?.quantity}</td>
                                                <td className='text-end'>{numberFormat(getReturnRowRate(row))}</td>
                                                <td className='text-end'>{numberFormat(getReturnRowAmount(row))}</td>
                                            </tr>
                                        )})}
                                        <tr>
                                            <td colSpan={5} className='text-end'><b>Total Return Amount : </b></td>
                                            <td className='text-end'><b>{numberFormat(
                                                (salesOrderReturn?.rows ?? []).reduce((sum: number, row: any) => sum + getReturnRowAmount(row), 0)
                                            )}</b></td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        )})}
                        <Table striped bordered hover size="sm" className="mt-3">
                            <tbody>
                                <tr>
                                    <td className='text-end' style={{ width: '83%' }}><b>Grand Total Return Amount : </b></td>
                                    <td className='text-end'><b>{numberFormat(getReturnTotalAmount())}</b></td>
                                </tr>
                                {isReturnOnlyInvoice() && Number(salesInvoiceInfo?.vatAmount ?? 0) !== 0 && (
                                    <tr>
                                        <td className='text-end'><b>VAT Amount : </b></td>
                                        <td className='text-end'><b>{numberFormat(salesInvoiceInfo?.vatAmount)}</b></td>
                                    </tr>
                                )}
                                {isReturnOnlyInvoice() && Number(salesInvoiceInfo?.discountAmount ?? 0) !== 0 && (
                                    <tr>
                                        <td className='text-end'><b>Discount Amount : </b></td>
                                        <td className='text-end'><b>{numberFormat(salesInvoiceInfo?.discountAmount)}</b></td>
                                    </tr>
                                )}
                                {isReturnOnlyInvoice() && Number(salesInvoiceInfo?.advanceAdjustment ?? 0) !== 0 && (
                                    <tr>
                                        <td className='text-end'><b>Adjustment : </b></td>
                                        <td className='text-end'><b>{numberFormat(salesInvoiceInfo?.advanceAdjustment)}</b></td>
                                    </tr>
                                )}
                                {isReturnOnlyInvoice() && (
                                    <tr>
                                        <td className='text-end'><b>Net Amount : </b></td>
                                        <td className='text-end'><b>{numberFormat(getReturnNetAmount())}</b></td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>
                )}

                <div className="card card-flush overflow-hidden m-2 me-0 shadow-sm border">
                    <div className="card-header py-4 bg-light">
                        <h3 className="card-title align-items-start flex-column mb-0">
                            <span className="card-label fw-bold text-dark">
                                <KTSVG className='svg-icon-4 me-2' path="/media/svg/icons/Shopping/Dollar.svg" />
                                Payments History
                            </span>
                        </h3>
                        {(salesInvoiceInfo?.payments?.length ?? 0) > 0 && (
                            <div className="card-toolbar">
                                <span className="badge badge-light-primary fs-7">
                                    Total Received: {numberFormat(
                                        salesInvoiceInfo?.payments?.reduce((sum: number, p: any) => sum + (parseFloat(p.payment_amount) || 0), 0) ?? 0
                                    )}
                                </span>
                                <span className="badge badge-light-info fs-7 ms-2">
                                    {salesInvoiceInfo?.payments?.length} payment(s)
                                </span>
                            </div>
                        )}
                    </div>
                    <div className="card-body pt-0">
                        <Row>
                            <Col>
                                <div className="table-responsive">
                                    <Table striped bordered hover size='sm' className="mb-0">
                                        <thead className="table-light">
                                            <tr>
                                                <th className='text-center text-nowrap' style={{ width: '6%' }}>ID</th>
                                                <th className='text-center text-nowrap' style={{ width: '8%' }}>Type</th>
                                                <th className='text-center text-nowrap' style={{ width: '10%' }}>Method</th>
                                                <th className='text-center text-nowrap' style={{ width: '10%' }}>Date</th>
                                                <th className='text-start' style={{ width: '12%' }}>Remarks</th>
                                                <th className='text-center text-nowrap' style={{ width: '10%' }}>Transaction ID</th>
                                                <th className='text-center text-nowrap' style={{ width: '12%' }}>Payment By</th>
                                                <th className='text-start' style={{ width: '16%' }}>Payment Info</th>
                                                <th className='text-end text-nowrap' style={{ width: '10%' }}>Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(!salesInvoiceInfo?.payments || salesInvoiceInfo.payments.length === 0) && (
                                                <tr>
                                                    <td colSpan={9} className="text-center py-8 text-muted">
                                                        <KTSVG className='svg-icon-5x text-gray-400 mb-2' path="/media/svg/icons/Shopping/Wallet.svg" />
                                                        <div className="fw-semibold">No payments yet</div>
                                                        <small>Payments will appear here when received for this invoice</small>
                                                    </td>
                                                </tr>
                                            )}
                                            {salesInvoiceInfo?.payments?.map((payment: any, index: number) => (
                                                <tr key={payment.id_sales_payments ?? index}>
                                                    <td className='text-center align-middle'>{payment.id_sales_payments}</td>
                                                    <td className='text-center align-middle'>
                                                        <span className={`badge ${payment.payment_type === 'regular' ? 'badge-light-success' : 'badge-light-warning'} fs-7`}>
                                                            {payment.payment_type}
                                                        </span>
                                                    </td>
                                                    <td className='text-center align-middle'>
                                                        <span className={`badge badge-light-primary fs-7`}>
                                                            {payment.payment_method?.replace('_', ' ')}
                                                        </span>
                                                    </td>
                                                    <td className='text-center align-middle'>{payment.payment_date}</td>
                                                    <td className='text-start align-middle'>{payment.remarks || '-'}</td>
                                                    <td className='text-center align-middle font-monospace'>{payment.transaction_id || '-'}</td>
                                                    <td className='text-center align-middle'>{(payment.creator?.first_name ?? '') + ' ' + (payment.creator?.last_name ?? '') || '-'}</td>
                                                    <td className='text-start align-middle small'>{payment.paymentInfo || '-'}</td>
                                                    <td className='text-end align-middle fw-semibold text-success'>{numberFormat(payment.payment_amount)}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                        {(salesInvoiceInfo?.payments?.length ?? 0) > 0 && (
                                            <tfoot className="table-light">
                                                <tr>
                                                    <td colSpan={8} className="text-end fw-bold">Total Received:</td>
                                                    <td className="text-end fw-bold text-success">
                                                        {numberFormat(
                                                            salesInvoiceInfo?.payments?.reduce((sum: number, p: any) => sum + (parseFloat(p.payment_amount) || 0), 0) ?? 0
                                                        )}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={8} className="text-end fw-bold">Invoice Amount:</td>
                                                    <td className="text-end fw-bold">{numberFormat(salesInvoiceInfo?.invoiceAmount ?? 0)}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={8} className="text-end fw-bold">Advance Adjustment:</td>
                                                    <td className="text-end fw-bold">{numberFormat(salesInvoiceInfo?.advanceAdjustment ?? 0)}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={8} className="text-end fw-bold">Balance Due:</td>
                                                    <td className={`text-end fw-bold ${(() => {
                                                        const invAmt = Number(salesInvoiceInfo?.invoiceAmount ?? 0);
                                                        const advAdj = Number(salesInvoiceInfo?.advanceAdjustment ?? 0);
                                                        const totalPaid = (salesInvoiceInfo?.payments?.reduce((sum: number, p: any) => sum + (parseFloat(p.payment_amount) || 0), 0) ?? 0);
                                                        return (invAmt - advAdj - totalPaid) > 0 ? 'text-danger' : 'text-success';
                                                    })()}`}>
                                                        {numberFormat(
                                                            Math.max(0, Number(salesInvoiceInfo?.invoiceAmount ?? 0) - Number(salesInvoiceInfo?.advanceAdjustment ?? 0) - (salesInvoiceInfo?.payments?.reduce((sum: number, p: any) => sum + (parseFloat(p.payment_amount) || 0), 0) ?? 0))
                                                        )}
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        )}
                                    </Table>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>

                <div className="card card-flush overflow-hidden m-2 me-0 shadow-sm border">
                    <div className="card-header py-4 bg-light">
                        <h3 className="card-title align-items-start flex-column mb-0">
                            <span className="card-label fw-bold text-dark">
                                <KTSVG className='svg-icon-4 me-2' path="/media/svg/icons/Design/Crop.svg" />
                                Advance Adjustment History
                            </span>
                        </h3>
                        {((salesInvoiceInfo as any)?.advanceAdjustments ?? (salesInvoiceInfo as any)?.advance_adjustments ?? []).length > 0 && (
                            <div className="card-toolbar">
                                <span className="badge badge-light-warning fs-7">
                                    Total Adjusted: {numberFormat(
                                        ((salesInvoiceInfo as any)?.advanceAdjustments ?? (salesInvoiceInfo as any)?.advance_adjustments ?? [])
                                            .reduce((sum: number, a: any) => sum + (parseFloat(a.adjusted_amount) || 0), 0)
                                    )}
                                </span>
                                <span className="badge badge-light-info fs-7 ms-2">
                                    {((salesInvoiceInfo as any)?.advanceAdjustments ?? (salesInvoiceInfo as any)?.advance_adjustments ?? []).length} adjustment(s)
                                </span>
                            </div>
                        )}
                    </div>
                    <div className="card-body pt-0">
                        <Row>
                            <Col>
                                {(!(salesInvoiceInfo as any)?.advanceAdjustments?.length && !(salesInvoiceInfo as any)?.advance_adjustments?.length) && (
                                    <div className="text-center py-8 text-muted">
                                        <KTSVG className='svg-icon-5x text-gray-400 mb-2' path="/media/svg/icons/Design/Crop.svg" />
                                        <div className="fw-semibold">No advance adjustments yet</div>
                                        <small>Advance adjustments will appear here when applied to this invoice</small>
                                    </div>
                                )}
                                {((salesInvoiceInfo as any)?.advanceAdjustments ?? (salesInvoiceInfo as any)?.advance_adjustments ?? []).map((adj: any, adjIndex: number) => (
                                    <div key={adj.id_sales_invoice_advance_adjustments ?? adjIndex} className={adjIndex > 0 ? 'mt-4' : ''}>
                                        <div className="d-flex align-items-center mb-2">
                                            <span className="badge badge-light-warning me-2">Adjustment #{adj.id_sales_invoice_advance_adjustments}</span>
                                            <small className="text-muted">
                                                {adj.created_at || '-'}
                                                {adj.creator && (
                                                    <> &middot; {(adj.creator.first_name ?? '') + ' ' + (adj.creator.last_name ?? '')}</>
                                                )}
                                            </small>
                                            <span className="fw-semibold text-warning ms-2">{numberFormat(adj.adjusted_amount)}</span>
                                        </div>
                                        <div className="table-responsive">
                                            <Table striped bordered hover size='sm' className="mb-0">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th className='text-center text-nowrap' style={{ width: '10%' }}>Payment ID</th>
                                                        <th className='text-center text-nowrap' style={{ width: '12%' }}>Transaction ID</th>
                                                        <th className='text-center text-nowrap' style={{ width: '12%' }}>Payment Date</th>
                                                        <th className='text-center text-nowrap' style={{ width: '12%' }}>Method</th>
                                                        <th className='text-start text-nowrap' style={{ width: '18%' }}>Payment By</th>
                                                        <th className='text-end text-nowrap' style={{ width: '12%' }}>Advance Amount</th>
                                                        <th className='text-end text-nowrap' style={{ width: '12%' }}>Adjusted Amount</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {(!adj.details || adj.details.length === 0) ? (
                                                        <tr>
                                                            <td colSpan={7} className="text-center text-muted py-4">No detail records</td>
                                                        </tr>
                                                    ) : (
                                                        (adj.details ?? []).map((detail: any, detailIndex: number) => {
                                                            const sp = detail.salesPayment ?? detail.sales_payment;
                                                            const payId = sp?.id_sales_payments ?? sp?.idSalesPayments ?? detail.id_sales_payments ?? '-';
                                                            const txId = sp?.transaction_id ?? sp?.transactionId ?? '-';
                                                            const payDate = sp?.payment_date ?? sp?.paymentDate ?? '-';
                                                            const payMethod = (sp?.payment_method ?? sp?.paymentMethod ?? '-').toString().replace('_', ' ');
                                                            const payBy = sp?.creator
                                                                ? ((sp.creator.first_name ?? sp.creator.firstName ?? '') + ' ' + (sp.creator.last_name ?? sp.creator.lastName ?? '')).trim()
                                                                : '-';
                                                            const advanceAmt = sp?.payment_amount ?? sp?.paymentAmount;
                                                            return (
                                                                <tr key={detail.id_sales_invoice_adjustment_details ?? detailIndex}>
                                                                    <td className='text-center align-middle'>{payId}</td>
                                                                    <td className='text-center align-middle font-monospace'>{txId}</td>
                                                                    <td className='text-center align-middle'>{payDate}</td>
                                                                    <td className='text-center align-middle'>
                                                                        <span className="badge badge-light-primary fs-7">{payMethod}</span>
                                                                    </td>
                                                                    <td className='text-start align-middle'>{payBy}</td>
                                                                    <td className='text-end align-middle'>{advanceAmt != null ? numberFormat(advanceAmt) : '-'}</td>
                                                                    <td className='text-end align-middle fw-semibold text-warning'>{numberFormat(detail.adjusted_amount)}</td>
                                                                </tr>
                                                            );
                                                        })
                                                    )}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                ))}
                                {((salesInvoiceInfo as any)?.advanceAdjustments ?? (salesInvoiceInfo as any)?.advance_adjustments ?? []).length > 0 && (
                                    <div className="mt-3 pt-3 border-top">
                                        <div className="d-flex justify-content-end fw-bold text-warning">
                                            Total Adjusted: {numberFormat(
                                                ((salesInvoiceInfo as any)?.advanceAdjustments ?? (salesInvoiceInfo as any)?.advance_adjustments ?? [])
                                                    .reduce((sum: number, a: any) => sum + (parseFloat(a.adjusted_amount) || 0), 0)
                                            )}
                                        </div>
                                    </div>
                                )}
                            </Col>
                        </Row>
                    </div>
                </div>



            </Col>
        </Row>
        {/* <pre>{JSON.stringify(salesInvoiceInfo, null, 2)}</pre> */}

        <SalesPaymentCreate
            show={createPaymentModalShow}
            handleClose={handleCreatePaymentModalClose}
            salesOrderInfo={salesOrderInfo}
            invoiceDetails={salesInvoiceInfo ? {
                id: (salesInvoiceInfo as any).id_sales_invoice ?? salesInvoiceInfo.idSalesInvoice,
                invoiceId: salesInvoiceInfo.invoiceId ?? (salesInvoiceInfo as any).invoice_id ?? '',
                invoiceAmount: Number(salesInvoiceInfo.invoiceAmount ?? (salesInvoiceInfo as any).invoice_amount ?? 0),
                advanceAdjustment: Number(salesInvoiceInfo.advanceAdjustment ?? (salesInvoiceInfo as any).advance_adjustment ?? 0),
                idSalesOrders: salesInvoiceInfo.idSalesOrders ?? (salesInvoiceInfo as any).id_sales_orders ?? 0,
            } : undefined}
        />

        {adjustmentModalData && (
            <AdvancePaymentAdjustmentModal
                show={showAdvanceAdjustmentModal}
                onClose={handleAdvanceAdjustmentClose}
                idCompanies={adjustmentModalData.idCompanies}
                idProjects={adjustmentModalData.idProjects}
                maxAdjustableAmount={adjustmentModalData.maxAdjustableAmount}
                totalInvoiceAmount={adjustmentModalData.totalInvoiceAmount}
                vatAmount={adjustmentModalData.vatAmount}
                discountAmount={adjustmentModalData.discountAmount}
                idSalesInvoice={parseInt(idSalesInvoice)}
                onSuccess={getSalesInvoiceInfo}
            />
        )}


    </>
    )
}

export default SalesInvoiceDetails
